import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — Pyng" },
      { name: "description", content: "Pyng uses minimal cookies — here's what and why." },
      { property: "og:title", content: "Cookie Policy — Pyng" },
      { property: "og:description", content: "Pyng uses minimal cookies — here's what and why." },
    ],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <LegalPage title="Cookie Policy" lastUpdated="May 2026">
      <p>Pyng uses cookies sparingly. We don't use third-party advertising or tracking cookies.</p>

      <h2>What we use</h2>
      <ul>
        <li><strong>Essential cookies:</strong> to keep you signed in and remember your session.</li>
        <li><strong>Functional storage:</strong> small amounts of local storage to remember your preferences (theme, last-viewed tab) so the app feels right.</li>
        <li><strong>Privacy-respecting analytics:</strong> aggregated, anonymized counts of page loads and errors. No personal profile is built.</li>
      </ul>

      <h2>What we don't use</h2>
      <ul>
        <li>No advertising cookies.</li>
        <li>No cross-site tracking.</li>
        <li>No selling your behavior to anyone.</li>
      </ul>

      <h2>Your choices</h2>
      <p>You can clear cookies anytime from your browser settings. Note that signing out and back in is required after clearing essential cookies.</p>
    </LegalPage>
  );
}
